import React from 'react';
import { Plus, RefreshCw, Trash2, CheckSquare, Square } from 'lucide-react';
import { fmt } from './constants';

export function AdminToolbar({
  search, filterCat, showInactive, selectedCount, syncing, syncMsg, rates, ratesTs,
  onSearchChange, onFilterCatChange, onToggleInactive, onSync, onBulkDelete, onAdd,
  categories,
}) {
  return (
    <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
      <div className="flex items-center gap-3 flex-wrap">
        <input
          value={search} onChange={e => onSearchChange(e.target.value)}
          placeholder="Search products..." data-testid="product-search"
          className="border border-[#E5E5E5] px-3 py-2 text-sm font-work w-44 focus:outline-none focus:border-[#D4AF37]"
        />
        <div className="flex gap-1 flex-wrap">
          {['', ...categories].map(c => (
            <button key={c} onClick={() => onFilterCatChange(c)}
              className={`px-3 py-1.5 text-xs uppercase tracking-wider font-work transition-colors ${filterCat === c ? 'bg-[#0A0A0A] text-white' : 'border border-[#E5E5E5] text-[#555555] hover:border-[#D4AF37]'}`}>
              {c || 'All'}
            </button>
          ))}
        </div>
        <button onClick={onToggleInactive}
          className={`px-3 py-1.5 text-xs uppercase tracking-wider font-work border transition-colors ${showInactive ? 'bg-red-50 border-red-200 text-red-500' : 'border-[#E5E5E5] text-[#AAAAAA] hover:border-[#D4AF37]'}`}>
          {showInactive ? 'Hide Inactive' : 'Show Inactive'}
        </button>
      </div>

      <div className="flex items-center gap-4">
        {ratesTs && (
          <span className="text-[10px] text-[#AAAAAA] font-work hidden lg:block" data-testid="live-rates-display">
            Live: USD {rates.USD?.toFixed(2)} · GBP {rates.GBP?.toFixed(2)} → ZAR
          </span>
        )}
        {syncMsg && (
          <span className={`text-[10px] font-work ${syncMsg.includes('failed') ? 'text-red-500' : 'text-[#2E7D32]'}`}
            data-testid="sync-msg">
            {syncMsg}
          </span>
        )}
        <button onClick={onSync} disabled={syncing}
          data-testid="sync-catalog-btn"
          className="border border-[#E5E5E5] text-[#555555] hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors px-4 py-2.5 text-xs uppercase tracking-widest font-semibold font-work flex items-center gap-2 disabled:opacity-40">
          <RefreshCw size={12} className={syncing ? 'animate-spin' : ''} />
          {syncing ? 'Syncing...' : 'Sync Catalog'}
        </button>
        {selectedCount > 0 && (
          <button onClick={onBulkDelete} data-testid="bulk-delete-btn"
            className="bg-red-500 text-white hover:bg-red-600 transition-colors px-4 py-2.5 text-xs uppercase tracking-widest font-semibold font-work flex items-center gap-2">
            <Trash2 size={13} /> Delete Selected ({selectedCount})
          </button>
        )}
        <button onClick={onAdd} data-testid="add-product-btn"
          className="bg-[#D4AF37] text-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white transition-colors px-4 py-2.5 text-xs uppercase tracking-widest font-semibold font-work flex items-center gap-2">
          <Plus size={13} /> Add Product
        </button>
      </div>
    </div>
  );
}
